import { useCallback } from "react";

import useRequest from "./useRequest";
import { API_SITES, BASE_ADMIN } from "../constants/api";
import { SiteSummary } from "../types/user";
import { DateDataBaseType } from "../types/database";

type SitesResponse = {
  data: SiteSummary[];
};

type SiteResponse = {
  data: SiteSummary & DateDataBaseType;
};

export type EditSite = {
  id?: number;
  name: string;
};

const useSites = () => {
  const { error, isLoading, response, request } = useRequest<SitesResponse>();

  const fetchSites = useCallback(() => {
    request(BASE_ADMIN, API_SITES, { secure: true });
  }, [request]);

  return {
    error,
    isLoading,
    sites: response?.data ?? null,
    fetchSites
  };
};

export const useSaveSite = () => {
  const { response: saved, error, request: saveRequest } = useRequest<SiteResponse>();

  const saveSite = useCallback((action: 'ADD' | 'UPDATE', site: EditSite, id?: number) => {
    const method = action === "ADD" ? "POST" : "PUT";
    const savePath = action === "UPDATE" && id ? `${API_SITES}/${id}` : API_SITES;
    saveRequest(BASE_ADMIN, savePath, { method, secure: true }, { name: site.name });
  }, [saveRequest]);

  return { saved, error, saveSite };
};

export const useDeleteSite = () => {
  const { request, response, error } = useRequest<{ message: string }>();

  const deleteSite = useCallback((id: number) => {
    request(BASE_ADMIN, `${API_SITES}/${id}`, { secure: true, method: 'DELETE' });
  }, [request]);

  return { deleteSite, response, error };
};

export default useSites;
